import {
  type ResumeLayout,
  type Settings,
} from "@/store/slices/settings.slice";

type TemplateDefaults = Pick<Settings, "sectionTitleAlignment" | "fontFamily" | "fontSize" | "themeColor" | "documentSize">;

export const RESUME_TEMPLATE_DEFAULTS: Record<ResumeLayout, TemplateDefaults> = {
  classic: { sectionTitleAlignment: "start", fontFamily: "Roboto", fontSize: "11", themeColor: "#334155", documentSize: "Letter" },
  modern: { sectionTitleAlignment: "start", fontFamily: "Lato", fontSize: "11", themeColor: "#075985", documentSize: "Letter" },
  design: { sectionTitleAlignment: "start", fontFamily: "OpenSans", fontSize: "10.5", themeColor: "#5b21b6", documentSize: "Letter" },
  ultra: { sectionTitleAlignment: "start", fontFamily: "RobotoSlab", fontSize: "10.5", themeColor: "#1e293b", documentSize: "Letter" },
  harvard: { sectionTitleAlignment: "start", fontFamily: "Caladea", fontSize: "11", themeColor: "#171717", documentSize: "Letter" },
  landfast: { sectionTitleAlignment: "start", fontFamily: "Roboto", fontSize: "11", themeColor: "#0f172a", documentSize: "Letter" },
  rezi2026: { sectionTitleAlignment: "start", fontFamily: "OpenSans", fontSize: "10.5", themeColor: "#111827", documentSize: "Letter" },
};

export const RESUME_TEMPLATES: ReadonlyArray<{
  layout: ResumeLayout;
  nameKey: string;
  descriptionKey: string;
  premium: boolean;
}> = [
  { layout: "classic", nameKey: "THEMEFORM_LAYOUT_CLASSIC_TEXT", descriptionKey: "THEMEFORM_LAYOUT_CLASSIC_DESC_TEXT", premium: false },
  { layout: "modern", nameKey: "THEMEFORM_LAYOUT_MODERN_TEXT", descriptionKey: "THEMEFORM_LAYOUT_MODERN_DESC_TEXT", premium: false },
  { layout: "design", nameKey: "THEMEFORM_LAYOUT_DESIGN_TEXT", descriptionKey: "THEMEFORM_LAYOUT_DESIGN_DESC_TEXT", premium: false },
  { layout: "harvard", nameKey: "THEMEFORM_LAYOUT_HARVARD_TEXT", descriptionKey: "THEMEFORM_LAYOUT_HARVARD_DESC_TEXT", premium: false },
  { layout: "landfast", nameKey: "THEMEFORM_LAYOUT_LANDFAST_TEXT", descriptionKey: "THEMEFORM_LAYOUT_LANDFAST_DESC_TEXT", premium: false },
  { layout: "rezi2026", nameKey: "THEMEFORM_LAYOUT_COMPACT_TEXT", descriptionKey: "THEMEFORM_LAYOUT_COMPACT_DESC_TEXT", premium: false },
  { layout: "ultra", nameKey: "THEMEFORM_LAYOUT_ULTRA_TEXT", descriptionKey: "THEMEFORM_LAYOUT_ULTRA_DESC_TEXT", premium: true },
];

export function isResumeTemplateLayout(value: string): value is ResumeLayout {
  return Object.hasOwn(RESUME_TEMPLATE_DEFAULTS, value);
}

export function getResumeTemplateSettings(settings: Settings, layout: ResumeLayout): Settings {
  const defaults = RESUME_TEMPLATE_DEFAULTS[layout];
  return {
    ...settings,
    ...defaults,
    layout,
  };
}
